import { Space, Typography } from 'antd'
import PropTypes from 'prop-types'

const { Title, Text } = Typography

const Header = ({ step }) => {
  return (
    <Space
      direction="vertical"
      size={13}
      align="center"
      style={{ textAlign: 'center', maxWidth: '750px' }}
    >
      {
        {
          reason: (
            <>
              <Title level={1} style={{ fontWeight: 'bold', margin: 0 }}>
                Você está perdendo os benefícios de sua assinatura
              </Title>
              <Text type="secondary" style={{ fontSize: '16px' }}>
                Ao cancelar seu plano Essencial, seus limites serão restaurados
                para o plano Grátis. Seus dados continuarão seguros por 30 dias.
              </Text>
            </>
          ),
          password: (
            <Title level={1} style={{ fontWeight: 'bold', margin: 0 }}>
              Para cancelar sua assinatura, insira sua senha
            </Title>
          ),
        }[step]
      }
    </Space>
  )
}

Header.propTypes = {
  step: PropTypes.oneOf(['reason', 'password', 'confirmation']).isRequired,
}

export default Header
